<template>
    <AuthComponent></AuthComponent>
    <SaveDialog :text="activation === 'true' ? 'Sikeresen aktiválta a fiókját' : 'Aktiváció sikertelen, kérem próbálkozzon újra'" okay-text="Rendben" :showdialog="activation != null" />
</template>

<script>
import { defineComponent } from 'vue'
import AuthComponent from '../components/AuthComponent.vue'
import SaveDialog from '../components/SaveDialog.vue';

export default defineComponent({
  name: 'HomePage',
  components: {
    AuthComponent,
    SaveDialog
  },
  data() {
    return {
      loading: true,
      isLoggedIn: false,
      activation: this.$route.query.activation,
    }
  },
})
</script>

<style scoped>
p {
  margin-top: 1rem;
  text-align: justify;
}
</style>
